import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import NewsList from "@/pages/home/components/NewsList";
import HotRank from "@/pages/home/components/HotRank";
import HotDramas from "@/pages/home/components/HotDramas";
import AboutStrip from "@/pages/home/components/AboutStrip";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta(
    "漂亮的保姆-影视剧资讯与剧情介绍",
    "漂亮的保姆为您带来全面的影视剧资讯和剧情介绍，涵盖相关电视剧内容及最新动态，方便用户了解剧情发展和演员信息。",
    "漂亮的保姆,影视剧,剧情介绍,电视剧资讯,演员介绍,影视内容,剧情解析",
  );

  return (
    <>
      <HeroCarousel />
      <CategoryGrid />
      <section className="bg-background-50 border-y border-background-200">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-10 md:py-14 grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2">
            <NewsList />
          </div>
          <aside className="lg:col-span-1">
            <HotRank />
          </aside>
        </div>
      </section>
      <HotDramas />
      <AboutStrip />
    </>
  );
}